export default {
    errorPage: {
      notFond: {
        security: '哎哟',
        Default: '请检查您输入的网址是否正确，或点击下面的按钮返回主页',
        DefaultRules: '返回主页',
        Minlength: '管理员说你不能进入这个页面…',
      },
      errorInfo: {
        back: '返回',
        security: '你没有权限去该页面',
        Maxerrors: '如有不满请联系你领导',
        MaxerrorsRules: '或者你可以去',
        Maxrecent: '回首页',
        errorscode: '随便看看',
        verification: '点我看图',
      }
    },
};
